import { NotificationMessage } from '@gravitate-js/excalibrr'
import { roundToNearestHalf } from '@utils/general'

export const validateLat = (params) => {
  let value = params.newValue
  if (!isNaN(value) && value >= -90 && value <= 90) {
    value = parseFloat(value.toFixed(4))
    params.data[params.colDef.field] = value
    return true
  }
  NotificationMessage('Latitude Out Of Range', 'Please select a value within -90 and 90')
  return false
}

export const validateLon = (params) => {
  let value = params.newValue
  if (!isNaN(value) && value >= -180 && value <= 180) {
    value = parseFloat(value.toFixed(4))
    params.data[params.colDef.field] = value
    return true
  }
  NotificationMessage('Longitude Out Of Range', 'Please select a value within -180 - 180')
  return false
}

export const validateServiceRadius = (params) => {
  const value = params.newValue
  if (!isNaN(value) && value > 0 && value < 3000) {
    params.data[params.colDef.field] = params.newValue
    return true
  }
  NotificationMessage('Invalid Service Radius', 'Please select a value within 0 and 3000')
  return false
}

export const validatePreTripMinutes = (params) => {
  const value = params.newValue
  if (!isNaN(value) && value >= 0 && value <= 300) {
    params.data[params.colDef.field] = params.newValue
    return true
  }
  NotificationMessage('Invalid Pre Trip Minutes', 'Please select a value within 0 and 300')
  return false
}
export const validatePostTripMinutes = (params) => {
  const value = params.newValue
  if (!isNaN(value) && value >= 0 && value <= 300) {
    params.data[params.colDef.field] = params.newValue
    return true
  }
  NotificationMessage('Invalid Post Trip Minutes', 'Please select a value within 0 and 300')
  return false
}
export const validateBreakMinutes = (params) => {
  const value = params.newValue
  if (!isNaN(value) && value >= 0 && value <= 300) {
    params.data[params.colDef.field] = params.newValue
    return true
  }
  NotificationMessage('Invalid Break Minutes', 'Please select a value within 0 and 300')
  return false
}
export const validateShiftLength = (params) => {
  const value = roundToNearestHalf(params.newValue)
  if (!isNaN(value) && value > 0 && value <= 24) {
    params.data[params.colDef.field] = value
    params.data.shift_length.shift_length_hours = value
    params.data.shift_length.type = 'depot'
    return true
  }
  NotificationMessage('Invalid Shift Length', 'Please enter a value within 0 and 24')
  return false
}
